import React from 'react'

const Follower = (follower) => 
{
  const { avatar_url:thumb, html_url:url, login:name } = follower;
  return (
  <article className = 'card'>
    <img src = {thumb} alt = {name} />
    <h4>{name}</h4>
    <a href={url} className = 'btn'>view profile</a>
  </article>);
}

export default Follower
